import { useTranslation } from "react-i18next";
import "./DashboardCardSkeleton.css";

interface DashboardCardSkeletonProps {
  count?: number;
  variant?: "default" | "compact";
}

const DashboardCardSkeleton = ({ count = 3, variant = "default" }: DashboardCardSkeletonProps) => {
  const { t } = useTranslation("common");
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`skeleton-card skeleton-card--${variant}`}
          role="status"
          aria-label={t("states.loading")}
        >
          {/* Icon placeholder */}
          <div className="skeleton-card__icon">
            <div className="skeleton-shimmer" />
          </div>

          {/* Header with title and chip */}
          <div className="skeleton-card__header">
            <div className="skeleton-card__title">
              <div className="skeleton-shimmer" />
            </div>
            <div className="skeleton-card__chip">
              <div className="skeleton-shimmer" />
            </div>
          </div>

          {/* Value placeholder */}
          <div className="skeleton-card__value">
            <div className="skeleton-shimmer" />
          </div>

          {/* Meta text placeholder */}
          <div className="skeleton-card__meta">
            <div className="skeleton-shimmer" />
          </div>
        </div>
      ))}
    </>
  );
};

export default DashboardCardSkeleton;
